'use client';

import { AnalyticsInitializer } from '@/lib/analytics/init';
import { TranslationProviderWrapper } from './translation-provider-wrapper';
export function ClientAnalyticsWrapper() {
  return <TranslationProviderWrapper data-sentry-element="TranslationProviderWrapper" data-sentry-component="ClientAnalyticsWrapper" data-sentry-source-file="client-analytics-wrapper.tsx">
      <AnalyticsInitializer data-sentry-element="AnalyticsInitializer" data-sentry-source-file="client-analytics-wrapper.tsx" />
    </TranslationProviderWrapper>;
}